module.exports = __webpack_public_path__ + "static/media/plaza-2_2.500423eb.webp";